import React from 'react';

import type { DateTimeContextProps, TextProps } from '@rtkwlf/fenrir-react';
import { Text } from '@rtkwlf/fenrir-react';
import dayjs from 'dayjs';

import { useDateFormatter } from '@packages/hooks/useDateFormatter';

export type DateTimeProps = {
  value: string | number | Date | undefined | null;
  format?: DateTimeContextProps['format'];
  overrideUtcFormat?: boolean;
  emptyPlaceholder?: string;
} & Omit<TextProps, 'children'>;

/**
 * TODO:
 * - Review the approach to not enforce a <Text> component. e.g. using with Field.Message
 * - fallback when invalid date
 */
/**
 * @deprecated use packages/components/date-time
 */
export const DateTime: React.FC<DateTimeProps> = ({
  value,
  format = 'prettyDateTime',
  overrideUtcFormat,
  emptyPlaceholder = '',
  ...rest
}) => {
  const formattedDate = useDateFormatter(
    value ?? '',
    format,
    overrideUtcFormat,
  );

  const shouldDisplayBlank =
    value === undefined || value === null || dayjs(value).year() <= 1;

  return (
    <Text
      data-testid="date-time"
      styledAs="body3"
      whiteSpace="nowrap"
      {...rest}
    >
      {shouldDisplayBlank ? emptyPlaceholder : formattedDate}
    </Text>
  );
};
